export {AuthBaseComponent} from "./auth-base/auth-base.component";
export {AuthLoginComponent} from "./auth-login/auth-login.component";
export {AuthRegisterComponent} from "./auth-register/auth-register.component";
export {AuthResetComponent} from "./auth-reset/auth-reset.component";
